import { useEffect, useState } from 'react';
import { getReconciliation } from '../../../helpers/getReconciliation';
import { dashboardActions } from '../../../../../store/slices/dashboardSlice/dashboardSlice';
import { useDispatch } from 'react-redux';

interface EstimateCalculations {
    estimate_name: string | null;
    vat_cost: number;
    order_completion_sum: number;
    customer_payment: number;
    customer_remain_payment_act: number;
    currency_short_code: string;
}

interface EstimatePayments {
    created_at: string | null;
    estimate_name: string | null;
    sum: number;
    currency_short_code: string;
    comment: string | null;
}

export interface ReconciliationInformation {
    estimates: EstimateCalculations[];
    total: EstimateCalculations[];
}

export interface RegistryInformation {
    estimates: EstimatePayments[];
    total: EstimatePayments[];
}

export const useModalBodyReconciliationOfCalculations = () => {
    const dispatch = useDispatch();
    const [calculations, setCalculations] = useState<ReconciliationInformation>({
        estimates: [],
        total: [],
    });
    const [payments, setPayments] = useState<RegistryInformation>({
        estimates: [],
        total: [],
    });
    useEffect(() => {
        const getData = async () => {
            dispatch(dashboardActions.onCustomerModalLoader(true));
            const res = await getReconciliation();

            if (res) {
                setCalculations(res.calculations);
                setPayments(res.payments);
            }

            dispatch(dashboardActions.onCustomerModalLoader(false));
        };

        getData();
    }, []);

    return {
        calculations,
        payments,
    };
};
